<template>
    <div class="lightbox">
      <div class="password-window col-12 pt3 pr4 pl4 pb3 border-box rounded-border box-shadow-big mx-auto bg-color-darkgray lightbox-box"> 
        <button class="lightbox-close-btn" @click="closePw()">
            <svg style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%) rotate(45deg);" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1V23" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M23 12H1" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <div v-show="recoverySuccess == 0">
          <div class="flex mb4">
            <div>
              <h2 class="h2 white bold">{{$t('forgot-pw_h_neues_pw')}}</h2>
            </div>
          </div>
          <div class="mb4">
            <p class="white">{{$t('forgot-pw_p_email_adresse')}}</p>
            <input class="user-input col-12 max-width-1" :placeholder="$t('forgot-pw_p_email_placeholder')" v-model="email">
          </div>
          <a class="btn btn-primary" @click="validateEmail()">{{$t('forgot-pw_a_passwort_anfordern')}}</a>
        </div>

        <div v-show="recoverySuccess == 1" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2">{{$t('forgot-pw_p_nachricht_nicht_versendet')}}</p>
          <p class="h4 color-gray pb4 center" v-html="$t('forgot-pw_p_eingabe_ueberpruefen')"></p>
          <div class="flex justify-center">
            <div>
              <a class="btn btn-small" @click="recoverySuccess = 0">{{$t('forgot-pw_a_erneut_eingeben')}}</a>
            </div>
            <div class="mx2"></div>
            <div>
              <a class="btn btn-small" @click="register()">{{$t('forgot-pw_btn_gotoregister')}}</a>
            </div>
          </div>
        </div>

        <div v-show="recoverySuccess == 2" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.48 6.4492C18.2132 6.25255 17.8792 6.17 17.5516 6.2197C17.2239 6.2694 16.9294 6.44729 16.733 6.7142L10.809 14.7542L7.042 11.7402C6.50174 11.3263 5.72976 11.4203 5.30453 11.9516C4.87929 12.483 4.95681 13.2568 5.479 13.6932L10.262 17.5192C10.529 17.728 10.8687 17.8208 11.2048 17.7766C11.5409 17.7324 11.8451 17.555 12.049 17.2842L18.749 8.1972C18.9453 7.92978 19.0272 7.59531 18.9768 7.26745C18.9263 6.93959 18.7476 6.64523 18.48 6.4492Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37256 5.37259 0 12 0C18.6245 0.00732422 23.9928 5.37549 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12ZM2 12C2 17.5229 6.47714 22 12 22C17.5203 21.9941 21.9939 17.5205 22 12C22 6.47705 17.5229 2 12 2C6.47714 2 2 6.47705 2 12Z" fill="white"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2">{{$t('forgot-pw_p_email_vorlaefig_pw')}}</p>
          <p class="h4 color-gray pb4 center">{{$t('forgot-pw_postfach_pruefen')}}</p>
          <div class="flex justify-center">
            <a class="btn btn-small" @click="closePw()">{{$t('forgot-pw_zurueck_zum_login')}}</a>
          </div>
        </div>

        <div v-show="recoverySuccess == 3 && !sendValidationSuccess && !sendValidationMailError" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2">
            {{$t('forgot-pw_p_infomessage_accountnotactivated')}}

          </p>
          <p class="h4 color-gray pb4 center" v-if="!sendValidationSuccess || !sendValidationMailError">
            {{$t('forgot-pw_p_infomessage_newpasswordquestion')}}
            </p>
          <p class="h4 pb4 center mt2 white" v-if="sendValidationSuccess">{{$t('forgot-pw_p_infomessage_newconfirmationmailsend')}}</p>
          <p class="h4 pb4 center mt2 white" v-if="sendValidationMailError">{{$t('forgot-pw_p_infomessage_mailcouldnotbesend')}}</p>
          <div class="flex justify-center align-middle">
            <div>
            <a class="btn btn-small" @click="closePw()">{{$t('forgot-pw_zurueck_zum_login')}}</a>
            </div>
            <div v-if="!sendValidationSuccess" class="mx2"></div>
            <div>
            <a class="btn btn-small" @click="sendValidationMail()" v-show="!sendValidationSuccess">{{$t('forgot-pw_btn_resendconfirmationmail')}}</a>
            </div>
          </div>
        </div>

        <div v-show="sendValidationSuccess" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.48 6.4492C18.2132 6.25255 17.8792 6.17 17.5516 6.2197C17.2239 6.2694 16.9294 6.44729 16.733 6.7142L10.809 14.7542L7.042 11.7402C6.50174 11.3263 5.72976 11.4203 5.30453 11.9516C4.87929 12.483 4.95681 13.2568 5.479 13.6932L10.262 17.5192C10.529 17.728 10.8687 17.8208 11.2048 17.7766C11.5409 17.7324 11.8451 17.555 12.049 17.2842L18.749 8.1972C18.9453 7.92978 19.0272 7.59531 18.9768 7.26745C18.9263 6.93959 18.7476 6.64523 18.48 6.4492Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0 12C0 5.37256 5.37259 0 12 0C18.6245 0.00732422 23.9928 5.37549 24 12C24 18.6274 18.6274 24 12 24C5.37259 24 0 18.6274 0 12ZM2 12C2 17.5229 6.47714 22 12 22C17.5203 21.9941 21.9939 17.5205 22 12C22 6.47705 17.5229 2 12 2C6.47714 2 2 6.47705 2 12Z" fill="white"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2">{{$t('forgot-pw_p_infomessage_newconfirmationmailsend')}}</p>
          <p class="h4 color-gray pb4 center">{{$t('forgot-pw_postfach_pruefen')}}</p>
          <div class="flex justify-center">
            <a class="btn btn-small" @click="closePw()">{{$t('forgot-pw_zurueck_zum_login')}}</a>
          </div>
        </div>

        <div v-show="sendValidationMailError" class="col-12 flex justify-center flex-column">
          <svg class="mx-auto" width="64" height="64" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 12C8.90111 12 8.80444 12.0293 8.72221 12.0843C8.63999 12.1392 8.5759 12.2173 8.53806 12.3087C8.50022 12.4 8.49032 12.5006 8.50961 12.5975C8.5289 12.6945 8.57652 12.7836 8.64645 12.8536C8.71637 12.9235 8.80546 12.9711 8.90245 12.9904C8.99944 13.0097 9.09998 12.9998 9.19134 12.9619C9.2827 12.9241 9.36079 12.86 9.41573 12.7778C9.47068 12.6956 9.5 12.5989 9.5 12.5C9.5 12.3674 9.44732 12.2402 9.35355 12.1464C9.25979 12.0527 9.13261 12 9 12Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 10V5" stroke="white" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="white" stroke-miterlimit="10"/>
          </svg>
          <p class="h2 white bold mx-auto center pt2 pb4">{{$t('forgot-pw_p_infomessage_mailcouldnotbesend')}}</p>
          <!-- <p class="h4 color-gray pb4 center">{{$t('forgot-pw_p_eingabe_ueberpruefen')}}</p> -->
          <div class="flex justify-center">
            <a class="btn btn-small" @click="closePw()">{{$t('forgot-pw_zurueck_zum_login')}}</a>
          </div>
        </div>

      </div>
    </div>
</template>

<script>

import { EventBus } from "@/event-bus";
import axios from 'axios'


export default {
  data() {
    return {
      debug: false,
      email: '',
      emailexists: true,
      recoverySuccess: 0,
      sendValidationSuccess: false,
      sendValidationMailError: false
    };
  },
  created: function () {
  },

  methods: {
    validateEmail(){
         let url = process.env.VUE_APP_APIENDPOINT + '/public-api/web-de/lostpassword-new/api/do';

      let currentObj = this;
      let data = {};
      data.email = this.email;

      axios.post(url, data)
        .then(response => {
          console.log(response)
         if(response.data.action == 'OK') {
           // Alles ist gut und wir könnten
           // response.data.message irgendwo anzeigen!
           this.recoverySuccess = 2
         } else if(response.data.action == 'NOTKNOWN') {
           // EMAIL NOT KNOWN
           this.recoverySuccess = 1
         }else if(response.data.action == 'NOTACTIVE'){
           // EMAIL KNOWN BUT NOT VALIDATED
           this.recoverySuccess = 3
         }
      }).catch(function () { currentObj.log('catch Function of AJAX-Called... error()');  });
    },

    closePw(){
      this.recoverySuccess = 0;
      this.sendValidationSuccess = false;
      this.sendValidationMailError = false;
      this.email = '';
      EventBus.$emit('closePw');
    },
    register(){
      this.recoverySuccess = 0;
      this.sendValidationSuccess = false;
      this.sendValidationMailError = false;
      this.email = '';
      EventBus.$emit('closePwOpenRegister');
    },
    sendValidationMail(){

      let useremail = {};
      useremail.email = this.email;
      useremail.channel = "quick-and-light-app-de"

      let createURL = process.env.VUE_APP_APIENDPOINT + '/register/api/sendemailagain'

      axios.post(createURL, useremail)
      .then(response => {
        console.log(response)
        if(response.data.success == 1){
          this.sendValidationSuccess = true;
          this.sendValidationMailError = false;
        }else{
          this.sendValidationSuccess = false;
          this.sendValidationMailError = true;
        }
      })
      .catch(function (error) {
        console.log(error)
      });
    },


    log: function (obj) {
      if(this.debug) {
        console.log(obj)
      }
    },
  },

};
</script>
<style>
</style>
